import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a2d] py-12 px-4" data-id="element-286">
      <div className="max-w-5xl mx-auto" data-id="element-287">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-288">
          <div data-id="element-289">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-290">
              +300
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-291">
              profes confían
            </div>
          </div>
          <div data-id="element-292">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-293">
              6+6
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-294">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-295">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-296">
              4.9/5
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-297">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-298">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-299">🌎</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-300">
              Todo el mundo hispanohablante
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-301">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-302">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-303">
              CR
            </div>
            <div data-id="element-304">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-305">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-306">
                "Organicé todo el año en una tarde. Ahora tengo cada clase
                pensada y secuenciada para todos mis grupos."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-307">
                — Carlos R., Ciudad de México | Profesor de Pádel en Club
                Deportivo
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-308">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-309">
              ML
            </div>
            <div data-id="element-310">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-311">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-312">
                "Las 40 clases por nivel con progresión real. Mis alumnos
                avanzan de categoría por primera vez."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-313">
                — Miguel L., Bogotá | Instructor de Pádel en Academia Privada
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-314">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-315">
              AP
            </div>
            <div data-id="element-316">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-317">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-318">
                "Adapto el mismo drill a 4 niveles distintos en 5 minutos. Antes
                me llevaba horas inventar."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-319">
                — Andrea P., Santiago de Chile | Profesora de Pádel
                Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}